export const SHOW_LIST_CLICK_ID = "202029";
export const SHOW_MAP_CLICK_ID = "202030";
